import Button from '../Button/ButtonComponent';
import ModalComponent from '../Modal';
import { useEffect, useState } from 'react';
import styles from './SaveLayout.module.scss';
import RadioButton from '../RadioButton/RadioButtonComponent';
import Text from '../Text/TextComponent';
import Flex from '../Flex/FlexComponent';
import LayoutWrapper from '../LayoutWrapper/LayoutWrapperComponent';
import { dataResources } from '@portal-internet/core';
import { ReactSVG } from 'react-svg';
import { useMutation } from 'react-query';
import __sortBy from 'lodash/sortBy';
import { useRedlMetadata } from 'hooks/useRedlMetadata';
import { REDLLayoutsSave } from '../../utils/constants';
import { useFetch } from '../../utils/fetch';
import { useRedl } from 'hooks/useRedl';
import LayoutChangesTmpStorageService from 'context/REDL/layoutChangesTmpStorageService';
import { useRedlLayout } from 'hooks/useRedlLayout';

const { basePath } = dataResources;

export default function SaveLayoutComponent() {
    const { setToastText } = useRedl();
    const [show, setShow] = useState(false);
    const { layout, pathname, setLayout, data } = useRedlLayout(show);
    const { getRedlPageRawLayout, isResetRedlPageMetadata, setIsResetRedlPageMetadata, clearLayoutChangesTmpStorage } = useRedlMetadata(pathname);

    const { hidePreview } = useRedl();
    const [hasChanges, setHasChanges] = useState(!isResetRedlPageMetadata());

    useEffect(() => {
        setHasChanges(!isResetRedlPageMetadata());
    }, [isResetRedlPageMetadata]);

    const { fetchMethod } = useFetch();

    const { mutate } = useMutation(fetchMethod, {
        onSuccess: () => {
            setToastText('Layout guardat correctament');
            setIsResetRedlPageMetadata(true);
            clearLayoutChangesTmpStorage();
        },
        onError: () => {
            setToastText("Hi ha hagut un error, el layout no s'ha pogut desar.");
        },
        onSettled: () => {
            setShow(false);
        }
    });

    const handleSubmit = () => {
        const { cache, allData, structure } = getRedlPageRawLayout();
        const sendableLayout = cache ? { cache, allData, structure } : { allData, structure };
        const dataToSend = {
            layout: {
                relpath: layout,
                data: sendableLayout
            }
        };
        mutate(
            { method: 'POST', url: window.jitConfig.apiREDLLayouts + REDLLayoutsSave, data: dataToSend },
            {
                onSuccess: () => {
                    LayoutChangesTmpStorageService.clear();
                    setIsResetRedlPageMetadata(true);
                }
            }
        );
    };

    return (
        <>
            <Button variant='primary' size='md' onClick={() => setShow(true)} disabled={hidePreview}>
                Desa{hasChanges ? ` canvis` : ``}
            </Button>
            <ModalComponent show={show} hideModal={() => setShow(false)}>
                <div className={styles.saveLayoutWrapper}>
                    <Text tag='h1' size='md' weight='400'>
                        Escull el destí del layout
                    </Text>
                    {data && (
                        <>
                            <div>
                                <LayoutWrapper>
                                    <Flex margin='0 0 16px 0'>
                                        <Text tag='h2' size='xs' weight='400'>
                                            Principal
                                        </Text>
                                        <Text tag='p' size='xs' weight='300'>
                                            Si esculls aquest layout els canvis es publicaran
                                        </Text>
                                    </Flex>

                                    <RadioButton
                                        name='layout'
                                        value={layout}
                                        option={data?.principal?.path}
                                        handleChange={setLayout}
                                    >
                                        <ReactSVG src={basePath + '/_resources/REDL/icons/layout.svg?v=JIT_ENV_RESOURCES_VERSION'} />
                                        <Text tag='span' size='xs' weight='400' transform='uppercase'>
                                            {data?.principal?.nom}
                                        </Text>
                                    </RadioButton>
                                </LayoutWrapper>

                                <LayoutWrapper>
                                    <Flex margin='0 0 16px 0'>
                                        <Text tag='h2' size='xs' weight='400'>
                                            Secundaris
                                        </Text>
                                        <Text tag='p' size='xs' weight='300'>
                                            Si esculls algun d’aquests layouts els canvis es desaran en un layout de treball que
                                            no es publicarà
                                        </Text>
                                    </Flex>

                                    {(Array.isArray(data?.secundaris) ? __sortBy(data?.secundaris, ['nom']) : []).map((l) => (
                                        <RadioButton
                                            name='layout'
                                            key={l.id}
                                            option={l.path}
                                            value={layout}
                                            handleChange={setLayout}
                                        >
                                            <ReactSVG src={basePath + '/_resources/REDL/icons/layout.svg?v=JIT_ENV_RESOURCES_VERSION'} />
                                            <Text tag='span' size='xs' weight='400' transform='uppercase'>
                                                {l.nom}
                                            </Text>
                                        </RadioButton>
                                    ))}
                                </LayoutWrapper>
                            </div>

                            <div className={styles.saveLayoutFooter}>
                                <Button variant='tertiary' size='sm-lg' onClick={() => setShow(false)}>
                                    Cancel·la
                                </Button>
                                <Button variant='primary' size='sm-lg' onClick={handleSubmit}>
                                    Confirmar
                                </Button>
                            </div>
                        </>
                    )}
                </div>
            </ModalComponent>
        </>
    );
}
